import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Card, Stack, TextField, Typography } from '@mui/material';
import { branchLogin } from '../../services/branchApi';

export default function BranchLogin() {
  const nav = useNavigate();
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      await branchLogin(identifier, password);
      nav('/branch/dashboard', { replace: true });
    } catch (err: any) {
      setError(err.message || 'Login failed');
    } finally { setLoading(false); }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'background.default' }}>
      <Card sx={{ p: 4, width: 380 }}>
        <Typography variant="h5" fontWeight={700} align="center">Branch Portal</Typography>
        <Typography variant="body2" color="text.secondary" align="center" sx={{ mb: 3 }}>
          Sign in to manage your branch
        </Typography>
        <form onSubmit={submit}>
          <Stack spacing={2}>
            <TextField label="Username or Email" size="small" value={identifier}
              onChange={(e) => setIdentifier(e.target.value)} autoFocus />
            <TextField label="Password" type="password" size="small" value={password}
              onChange={(e) => setPassword(e.target.value)} />
            {error && <Typography color="error" variant="body2">{error}</Typography>}
            <Button type="submit" variant="contained" disabled={loading || !identifier || !password}>
              {loading ? 'Signing in…' : 'Sign In'}
            </Button>
          </Stack>
        </form>
      </Card>
    </Box>
  );
}
